export default class LaveriesMap {
	constructor() {
		if ($('#laveries-map').length) {
			LaveriesMap.map();
		}
	}

	static map() {
		let locations = $.parseJSON(Theme.laveries);
		let center = {lat: 46.854075, lng: 2.535098}
		let zoom = 6.5;

		if (locations.length == 1) {
			center = {lat: locations[0].coords.lat * 1, lng: locations[0].coords.lng * 1}
			zoom = 15;
		}

		let map = new google.maps.Map(document.getElementById('laveries-map'), {
			center: center,
			zoom: zoom,
			styles: [
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				}
			]
		});

		let bounds = new google.maps.LatLngBounds();

		var markers = locations.map(function (location, i) {
			//Create maker
			let marker = new google.maps.Marker({
				position: {lat: location.coords.lat * 1, lng: location.coords.lng * 1},
				icon: Theme.themeURL + '/assets/dist/images/markers/marker.png',
				title: location.title
			});

			// Extend bound with the new marker
			bounds.extend({lat: location.coords.lat * 1, lng: location.coords.lng * 1});

			// Create infowindow content
			let address = '<span class="street">' + location.address.street + '</span>';
			if (location.address.street2) {
				address += '<br /><span class="street2">' + location.address.street2 + '</span>'
			}
			if (location.address.zipcode || location.address.city || location.address.region) {
				let line2 = [];
				if (location.address.zipcode) {
					line2.push('<span class="zipcode">' + location.address.zipcode + '</span>');
				}
				if (location.address.city) {
					line2.push('<span class="city">' + location.address.city + '</span>');
				}
				if (location.address.region.label) {
					line2.push('<span class="region">' + location.address.region.label + '</span>');
				}

				if (line2.length) {
					address += '<br />' + line2.join(', ');
				}
			}

			if (location.address.phone) {
				address += '<br /><span class="phone">' + Theme.translate.phone + ' : ' + location.address.phone + '</span>';
			}
			if (location.address.phone2) {
				address += '<br /><span class="phone2">' + Theme.translate.phone + ' : ' + location.address.phone2 + '</span>';
			}
			if (location.address.email) {
				address += '<br /><span class="email">Email : ' + location.address.email + '</span>';
			}
			if (location.address.website) {
				address += '<br /><span class="website">' + Theme.translate.website + ' : <a href="' + location.address.site + '" target="_blank">' + location.address.site + '</a></span>';
			}
			if (location.address.openings) {
				address += '<br /><span class="openings">' + Theme.translate.openings + ' : ' + location.address.openings + '</span>';
			}


			let infoWindowContent = '' +
				'<div class="infoWindow">' +
				'   <div class="infoWindowTitle">' + location.title + '</div>' +
				'   <div class="infoWindowContent">' +
				'       <p class="infoWindowContentAddress">' + address + '</p>' +
				'   </div>' +
				'   <div class="infoWindowLinks">' +
				'       <a href="' + location.url + '" class="button">' + Theme.translate.show + '</a>' +
				'   </div>' +
				'</div>';

			// Create the infowindow
			let infoWindow = new google.maps.InfoWindow({
				content: infoWindowContent
			});

			// Infowindow click event listener
			marker.addListener('click', function () {
				infoWindow.open(map, marker);
			});

			return marker;
		});

		if (locations.length > 1) {
			map.fitBounds(bounds);
		}

		var markerCluster = new MarkerClusterer(map, markers,
			{imagePath: Theme.themeURL + '/assets/dist/images/markers/marker'});
	}
}
